'use strict';

module.exports = {
    ...require('./global'),
    ...require('./account'),
    ...require('./cart'),
    ...require('./newsletter'),
    ...require('./wishlist'),
    ...require('./promotionAndInfo'),
    ...require('./findYourStore'),
    ...require('./product'),
    ...require('./video'),
    ...require('./scalaPay'),
    ...require('./refund'),
    ...require('./digitalWallet')
};
